import React, { FC } from "react";

type IProps = {
  width?: string;
  height?: string;
  color?: string;
};

const Pause: FC<IProps> = ({ width, height, color }) => {
  return (
    <svg
      width={width ? width : "40"}
      height={height ? height : "40"}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="40" height="40" rx="20" fill="#FD8533" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.5 13C15.6716 13 15 13.6716 15 14.5V25.5C15 26.3284 15.6716 27 16.5 27C17.3284 27 18 26.3284 18 25.5V14.5C18 13.6716 17.3284 13 16.5 13ZM23.5 13C22.6716 13 22 13.6716 22 14.5V25.5C22 26.3284 22.6716 27 23.5 27C24.3284 27 25 26.3284 25 25.5V14.5C25 13.6716 24.3284 13 23.5 13Z"
        fill="white"
      />
    </svg>
  );
};

export default Pause;
